import { useState } from "react"

const useBooleanStage = initialState => {
    const [state, setState] = useState(initialState)
    return [state, () => setState(true), () => setState(false)]
}

export default useBooleanStage